import { Icon } from "../Icon.js";
import controlled_substance_gray_default from "../static/controlled-substance-gray.js";
import controlled_substance_secondary_default from "../static/controlled-substance-secondary.js";
import controlled_substance_default from "../static/controlled-substance.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconControlledSubstance.tsx
/* istanbul ignore file -- @preserve */
const IconControlledSubstance = ({ color, height, style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: color === "secondary" ? controlled_substance_secondary_default : color === "gray" ? controlled_substance_gray_default : controlled_substance_default,
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconControlledSubstance };